export default __webpack_public_path__ + "static/media/martins-logo.373b5cbf.png";